<template>
  <div v-if="list && list.length" class="material-group">
    <div class="group-title">{{ title }}</div>
    <div class="material-list">
      <div
        v-for="(item, index) in list"
        :key="`${item.name || ''}-${index}`"
        class="material-item"
      >
        <div class="material-dot"></div>
        <div class="material-content">
          <div class="material-name">{{ item.name }}</div>
          <div class="material-desc">{{ formatAttention(item.attention) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionCarryMaterialGroup',
  props: {
    title: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatAttention(attention) {
      if (!attention) return '';
      if (Array.isArray(attention)) return attention.join('\n');
      return attention;
    },
  },
};
</script>

<style lang="less" scoped>
.material-group {
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }

  .group-title {
    margin-bottom: 6px;
    color: #333;
    font-weight: 500;
    font-size: 13px;
    line-height: 22px;
  }

  .material-list {
    box-sizing: border-box;
    padding: 10px;
    border: 0.5px solid #e9eef2;
    border-radius: 4px;
    background: #fafbfc;
  }

  .material-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 6px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .material-dot {
    flex-shrink: 0;
    width: 5px;
    height: 5px;
    margin: 8.5px 8px 0 0;
    border-radius: 50%;
    background: #91999f;
  }

  .material-content {
    flex: 1;
    overflow: hidden;
  }

  .material-name {
    color: #333;
    font-size: 12px;
    line-height: 21px;
    white-space: pre-wrap;
    word-break: break-all;
  }

  .material-desc {
    color: #a6a6a6;
    font-size: 12px;
    line-height: 21px;
    white-space: pre-wrap;
    word-break: break-all;
  }
}
</style>
